module.exports = __webpack_public_path__ + "0aaac317fd67c90a16686e15041c1a46.png";